import { render, staticRenderFns } from "./DuplicateItem.vue?vue&type=template&id=2bfd0704&scoped=true"
import script from "./DuplicateItem.vue?vue&type=script&lang=js"
export * from "./DuplicateItem.vue?vue&type=script&lang=js"
import style0 from "./DuplicateItem.vue?vue&type=style&index=0&id=2bfd0704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd0704",
  null
  
)

export default component.exports